import { Check, X } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { useSkillDetailContext } from '@/hooks'

export function SkillSectionActions() {
  const { skill, canEdit, isDirty, isSaving, saveBlockedReason, onSave, onCancel } = useSkillDetailContext()

  if (!canEdit) return null

  return (
    <div className="flex flex-wrap items-center justify-end gap-2">
      <Button
        variant="ghost"
        onClick={onCancel}
        disabled={isSaving || (skill !== null && !isDirty)}
        className="font-semibold"
        data-testid="cancel-skill-button"
      >
        <X className="h-4 w-4" />
        Cancel
      </Button>
      <Button
        onClick={onSave}
        disabled={saveBlockedReason !== null}
        title={saveBlockedReason ?? undefined}
        data-testid="save-skill-button"
      >
        <Check className="h-4 w-4" />
        {isSaving ? 'Saving...' : 'Save Skill'}
      </Button>
    </div>
  )
}
